import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/.pnpm/next-intl@4.3.12_next@15.5.9_@babel+core@7.28.4_@opentelemetry+api@1.9.0_react-dom@19.1_cbad66f3c37919ccf67e10742f1eb817/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.5.9_@babel+core@7.28.4_@opentelemetry+api@1.9.0_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["Goto"] */ "/vercel/path0/src/features/presentations/Goto.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Match","MatchPair"] */ "/vercel/path0/src/features/presentations/Match.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Quiz","QuizQuestion","QuizOption","QuizExplanation"] */ "/vercel/path0/src/features/presentations/Quiz.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Timer"] */ "/vercel/path0/src/features/presentations/Timer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ZoomableImage"] */ "/vercel/path0/src/features/presentations/ZoomableImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MarkdocCodeEditor"] */ "/vercel/path0/src/shared/blog/components/MarkdocCodeEditor.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Prompt"] */ "/vercel/path0/src/shared/components/Prompt.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Avatar","AvatarImage","AvatarFallback"] */ "/vercel/path0/src/shared/components/ui/avatar.tsx");
